$(function() {
    let $popup = $('.js-popup');
    let $popupCloseBtn = $('.js-popup-close');
    let lastOpenedPopup = null;
    let scrollPosition;

    if (location.hash !== '') {
        $(`.js-popup[data-block='${location.hash.substr(1)}']`).addClass('is-show');
        scrollPosition = $(window).scrollTop();
    }

    var popupTrigger = document.getElementById("openpopup");
    if (popupTrigger) {
        openPopup($('#openpopup').attr('data-link'), $('#openpopup').attr('data-href'), '');
    }

    $B.on('click', '.js-popup-link', function(e) {
        e.preventDefault();
        let $this = $(this);
        let target = $this.attr('data-link');
        let href = $this.attr('data-href');
        let videoSrc = $this.attr('data-src');

        openPopup(target, href, videoSrc);

        if (typeof $this.data('scrollto') !== 'undefined') {
            setTimeout(function() {
                let form = $('.js-ajax-wrapper').find('form');
                if (form.length) {
                    form.find('input:not([type="hidden"])').first().focus();
                }
            }, 1500);
        }

        return false;
    });



    function openPopup(target, href, videoSrc) {
        const $elem = $('.js-popup[data-block="' + target + '"]');
        $('div.popup:not(.js-popup[data-block=ajax-content],.js-popup[data-block=ajax-content-page])').removeClass('is-show');
        $elem.addClass('is-show');

        // $popup.not($('.js-popup[data-block=ajax-content]')).not($('.js-popup[data-block=ajax-content-page]')).removeClass('is-show');
        $elem.addClass('is-show');

        scrollPosition = $(window).scrollTop();

        let video = $elem.find('.js-iframe');
        video.attr('src', videoSrc);

        // if (target !== 'media') {
        // 	location.hash = target;
        // }

        scrollPosition = $(window).scrollTop();

        if (href) {
            history.pushState({}, '', href);
            $('.js-popup[data-block="' + target + '"]').find('.js-ajax-wrapper').empty();
            getEventItem(href, $('.js-popup[data-block="' + target + '"]'));
            lastOpenedPopup = 'href';
            $B.addClass('is-blur');
        }
    }

    window.openPopup = openPopup;



    $B.on('click', '.js-popup-close', function() {
        let $this = $(this);
        let $popup = $this.closest('.js-popup');
        $popup.removeClass('is-show');
        $popup.find('.js-iframe').attr('src', '');
        $B.removeClass('is-blur');
        $popup.find('.js-ajax-wrapper').html('');
        

        if (scrollPosition !== "undefined") {
            $(window).scrollTop(scrollPosition);
            scrollPosition = undefined;
        }

        setTimeout(function(){
            let path = window.location.pathname.split("/");
            let strippedPath = path.slice(0, path.length-2).join("/");
            // window.location.pathname = strippedPath
            window.history.pushState(null, null, strippedPath); 
        }, 500);
        
        if (lastOpenedPopup === 'href') {

            let scrollPositionLast = $(window).scrollTop();
            lastOpenedPopup = null;
        }

        if ( $('.js-gallery-slider-ajax').length ) {
            $('.js-gallery-slider-ajax').find('.swiper-slide-active video').trigger('pause');
        }



    });

    $B.on('click', '.js-popup[data-block=ajax-content] .js-popup-close', function() {
        $popup.removeClass('is-show');
    });

    $B.on('click', '.js-popup[data-block=ajax-content-page] .js-popup-close', function() {
        $popup.removeClass('is-show');
    });

    function getEventItem(item, elem) {
        $.ajax({
            url: item,
            type: "GET",
            data: { async: 1 },
            success: function(data) {
                if ($(data).length !== 0) {
                    elem.find('.js-ajax-wrapper').html($(data).hide().fadeIn(1000));

                    setTimeout(function() {
                        formValidate();
                        multipleSwiperThumb();
                        iframeUrl();
                        sliderImages();
                        magneticButtons();
                    }, 1000);

                }
            }
        });
    }

    $B.on('click', '.js-open-text', function(e) {
        e.preventDefault();
        let $this = $(this);
        let $popup = $this.closest('div');
        let hiddenBlock = $popup.find('.article-text-hidden');
        hiddenBlock.toggleClass('is-active');
        $this.toggleClass('is-active')

        if ($this.text() === 'Читать далее') {
            $this.text('Скрыть')
        } else if ( ($this.text() === 'Читать еще') ) {
             $this.text('Скрыть')
        } else {
            $this.text('Читать еще')
        }
    })
});